(async section_name => {
    const track = document.querySelector(`.${section_name}_wrapper`);
    const bar = document.querySelector(`.${section_name}_bottom_sticky_bar`);
    let atFooter = !1;
    let atHero = !0;
    if (!bar || !track) return;
    let debounce = false;
    new IntersectionObserver(([{isIntersecting}])=>{
        clearTimeout(debounce);
        atHero=isIntersecting;
        debounce=setTimeout(()=>{atFooter || (bar.dataset.show=+(window.scrollY > track.scrollHeight/2))},400);
    },{"threshold":Array.from({length:10},(_,i)=>(i+1)/10)}).observe(track);
    setTimeout(()=>{
        const track = document.querySelector(`footer.shopify-section--footer`);
        if (!track) return;
        new IntersectionObserver(([{isIntersecting}])=>{
            clearTimeout(debounce);
            atFooter=isIntersecting;
            debounce=setTimeout(()=>{atHero || (bar.dataset.show=+!isIntersecting)},400);
        },{"threshold":[.1]}).observe(track);
    },500);
})("acc-st-landingpage-102_01").catch(console.info);
